import { IMpnRequest } from "../../../types/data.interface";
import { CreateMpnState } from "../states/create/data";
import { itemNumberDTO } from "./getItemNumber";

export const mpnResponseDto = (mpn: IMpnRequest): CreateMpnState => {
  const mpnRequest: CreateMpnState = {
    mpnData: {
      //@ts-ignore
      comments: mpn.comments,
      //@ts-ignore
      giftbox: mpn.gift_box,
      //@ts-ignore
      production_lifecycle_status: mpn.production_lifecycle_status,
      //@ts-ignore
      project_id: mpn.project_id,
      //@ts-ignore
      sales_lifecycle_status: mpn.sales_lifecycle_status,
      //@ts-ignore
      name: mpn.item_description,
      //@ts-ignore
      stdpk: mpn.standard_pack,
      //@ts-ignore
      stdpk_height: mpn.std_pk_size_h,
      //@ts-ignore
      stdpk_length: mpn.std_pk_size_l,
      //@ts-ignore
      stdpk_width: mpn.std_pk_size_w,
      //@ts-ignore
      stdpk_weight: mpn.std_pk_wgt,
      //@ts-ignore
      product_use: mpn.product_use,
      //@ts-ignore
      reldt: mpn.release_date,
      //@ts-ignore
      tps_product: mpn.tps_product,
      //@ts-ignore
      tps_loc_id: mpn.tps_loc_id,
      //@ts-ignore
      tps_type_id: mpn.tps_type_id,
      //   @ts-ignore
      length: mpn.prod_dim_l,
      //   @ts-ignore
      width: mpn.prod_dim_w,
      //   @ts-ignore
      height: mpn.prod_dim_h,
      //   @ts-ignore
      cntwgt: mpn.cntwgt,
      //   @ts-ignore
      pgrwgt: mpn.pgrwgt,
      //   @ts-ignore
      pntwgt: mpn.pntwgt,
    },

    mpnRequest: { ...mpn },
    //@ts-ignore
    composition: JSON.parse(mpn.sku_composition),
    //@ts-ignore
    itemNumber: itemNumberDTO(mpn.tcc),

    category: mpn?.category || mpn?.global_product?.sub_category.parent,
    sub_category: mpn?.sub_category || mpn?.global_product?.sub_category,
    product_line: mpn?.product_line || mpn?.global_product?.product_line,
    global_product: mpn?.global_product,

    //@ts-ignore
    requestorInfo: mpn.res_pm_market,
    fusionSupplier : mpn.fusion_supplier
  };

  return mpnRequest;
};
